export default "__VITE_ASSET__DYuf3ybq__"